import React from 'react';
import './WebChips.css';

const SECONDARY_VALUES = new Set(['cancel', 'no', 'skip', 'back', 'dismiss', 'nevermind']);
const AFFIRMATIVE_VALUES = new Set(['yes', 'confirm', 'ok', 'okay', 'submit', 'accept', 'approve']);

const chipVariant = (chip) => {
  const v = (chip?.value || '').toLowerCase().trim();
  if (SECONDARY_VALUES.has(v)) return 'secondary';
  if (AFFIRMATIVE_VALUES.has(v)) return 'affirmative';
  return '';
};

const WebChips = ({ chips, onSelect, disabled = false }) => {
  if (!Array.isArray(chips) || chips.length === 0) return null;

  return (
    <div className="web-chips" role="group" aria-label="Quick replies">
      {chips.map((chip, idx) => {
        if (!chip || typeof chip.value !== 'string') return null;
        const variant = chipVariant(chip);
        return (
          <button
            key={`${chip.value}-${idx}`}
            type="button"
            className={`web-chip${variant ? ` web-chip--${variant}` : ''}`}
            onClick={() => onSelect(chip.value)}
            disabled={disabled}
          >
            <span className="web-chip__label">{chip.label || chip.value}</span>
          </button>
        );
      })}
    </div>
  );
};

export default WebChips;
